module.exports = __webpack_public_path__ + "img/TAI2015.d07035d5.png";